import { Skeleton } from "@/components/ui/skeleton.tsx";
import { ConditionIcon } from "@/features/weather/components/condition-icon.tsx";
import {
	formatTemp,
	HourlyStrip,
} from "@/features/weather/components/hourly-strip.tsx";
import { WeatherAlert } from "@/features/weather/components/weather-alert.tsx";
import { WorkableBadge } from "@/features/weather/components/workable-badge.tsx";
import { useWeather } from "@/features/weather/hooks/use-weather.ts";

const HOURLY_LIMIT = 4;

export function WeatherCard() {
	const { query, hasContext } = useWeather();

	if (!hasContext || query.isError) {
		return (
			<div className="kpi-card weather-card" data-state="empty">
				<p className="kpi-card__label">Clima</p>
				<p className="dashboard-panel-error" role="status">
					Previsão indisponível para esta obra.
				</p>
			</div>
		);
	}

	const weather = query.data;
	if (!weather) {
		return (
			<div className="kpi-card weather-card" data-state="loading">
				<p className="kpi-card__label">Clima</p>
				<Skeleton className="weather-card__skeleton" />
			</div>
		);
	}

	const hours = weather.hourly.slice(0, HOURLY_LIMIT);

	return (
		<div className="kpi-card weather-card">
			<div className="kpi-card__header">
				<ConditionIcon
					condition={weather.condition}
					className="kpi-card__icon"
				/>
				<p className="kpi-card__label">Clima</p>
				<WorkableBadge
					workable={weather.workable}
					className="weather-card__badge"
				/>
			</div>
			<div className="weather-card__current">
				<p className="kpi-card__value">{formatTemp(weather.temp)}</p>
				<p className="kpi-card__sub">{weather.description}</p>
			</div>
			{hours.length > 0 && <HourlyStrip hours={hours} />}
			{weather.alert && (
				<WeatherAlert
					message={weather.alert}
					title={weather.alert}
					className="weather-card__alert"
				/>
			)}
		</div>
	);
}
